import { render, staticRenderFns } from "./register-info.vue?vue&type=template&id=3988484f&scoped=true&"
import script from "./register-info.vue?vue&type=script&lang=js&"
export * from "./register-info.vue?vue&type=script&lang=js&"
import style0 from "./register-info.vue?vue&type=style&index=0&id=3988484f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3988484f",
  null
  
)

export default component.exports